module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAICAYAAAAvOAWIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA/SURBVHgBrZDBCQAgDAOjC+kIuomjuKmjxPhXrNKDgz4aaAMcINlkhoW1KMd3IGjol0ySRdYIL8x3Pz24q24CoEs6HZ5VPVAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/renew_mobile/right_arrow.png
// module id = Sr4o
// module chunks = 0